export enum RoutePattern {
  HOME = "home",
  ARTIST = "artists",
  RELEASES = "releases",
  ABOUT = "about",
  MEDIABRANDS = "media-brands",
  SHOP = "shop",
  TOUR = "tour",
  MUSIC = "music",
  VIDEOS = "videos",
}
